module.exports = __webpack_public_path__ + "static/media/video_image1.04d2e2bc.png";